// extracted by mini-css-extract-plugin
module.exports = {"text":"WLMUWy","button":"_2Mi5Nf","shine-lines":"_2rdVCR"};